import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";
import { API_URL } from "./api";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function resolveAvatarUrl(url: string | null | undefined) {
  if (!url) return "";
  if (url.startsWith("http")) return url;
  // If API_URL has /v1, remove it.
  const baseUrl = API_URL.replace(/\/v1\/?$/, "");
  return `${baseUrl}${url}`;
}
